export const DEFAULTS = {
  video: 'data-comp-custom-video',
  playButton: 'data-comp-custom-video-play-button',
  muteButton: 'data-comp-custom-video-mute-button',
};

export const STATES = {
  playing: 'data-comp-custom-video-playing',
  muted: 'data-comp-custom-video-muted'
};
